import React, { useState, useEffect } from "react";
import {
    Container,
    Typography,
    Paper,
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    Button,
    AppBar,
    Toolbar
} from "@mui/material";
import { collection, query, getDocs, orderBy } from "firebase/firestore";
import { auth, db } from "../firebase";
import { signOut } from "firebase/auth";

const TimeEntryDisputesDashboard = ({ orgId }) => {
    const [loading, setLoading] = useState(true);
    const [disputes, setDisputes] = useState([]);

    useEffect(() => {
        if (orgId) {
            fetchDisputes();
        }
    }, [orgId]);

    const fetchDisputes = async () => {
        if (!orgId) return;

        setLoading(true);
        try {
            // Example query - adjust as needed based on your data structure
            const disputesRef = collection(db, "organizations", orgId, "disputes");
            const q = query(disputesRef, orderBy("createdAt", "desc"));
            const snapshot = await getDocs(q);

            const disputesData = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setDisputes(disputesData);
        } catch (err) {
            console.error("Error fetching disputes:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = async () => {
        await signOut(auth);
        window.location.href = "/login";
    };

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        TimeWarden Admin
                    </Typography>
                    <Button color="inherit" onClick={handleLogout}>Logout</Button>
                </Toolbar>
            </AppBar>

            <Container maxWidth="lg">
                <Paper sx={{ mt: 5, p: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h5">Time Entry Disputes Dashboard</Typography>
                        <Button
                            variant="contained"
                            onClick={fetchDisputes}
                        >
                            Refresh
                        </Button>
                    </Box>

                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                            <CircularProgress />
                        </Box>
                    ) : disputes.length === 0 ? (
                        <Typography variant="body1">No disputes found.</Typography>
                    ) : (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Employee</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {disputes.map((dispute) => (
                                    <TableRow key={dispute.id}>
                                        <TableCell>{dispute.employeeEmail}</TableCell>
                                        <TableCell>
                                            {dispute.date && dispute.date.toDate ?
                                                dispute.date.toDate().toLocaleDateString() :
                                                "Unknown date"}
                                        </TableCell>
                                        <TableCell>{dispute.type}</TableCell>
                                        <TableCell>{dispute.description}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={dispute.status}
                                                color={
                                                    dispute.status === "approved" ? "success" :
                                                        dispute.status === "rejected" ? "error" :
                                                            "warning"
                                                }
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => {/* Implement view/update functionality */ }}
                                            >
                                                Review
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </Paper>
            </Container>
        </>
    );
};

export default TimeEntryDisputesDashboard;